export const SET_CONTENT_COLUMN_COUNT = 'SET_CONTENT_COLUMN_COUNT';
export const setContentColumnCount = value => ({ type: SET_CONTENT_COLUMN_COUNT, value });
